import React, { useContext, useEffect, useState } from "react";
import { Table, Button, Card, Tabs, Image, Radio } from "antd";
import { ReloadOutlined, PlusOutlined, EditOutlined } from "@ant-design/icons";
import ProductModal from "../../components/AddNewProductModal/ProductModal";
import listApi from "../../services/api";
import { AuthContext } from "../../context/AuthContext";

const { TabPane } = Tabs;

const NewsManagement = () => {
  const { userData } = useContext(AuthContext);
  const [selectedNews, setSelectedNews] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [news, setNews] = useState([])
  const [editingNews, setEditingNews] = useState(null);
  
  useEffect(() => {
    fetchNews();
  }, []);

  const fetchNews = async () => {
    setLoading(true);
    try {
      const response = await fetch(listApi.listNews,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            session_id: userData.session_id
          })
        });
      const data = await response.json();
      if (data.code === 200) {
        setNews(data.list_news.map(news => ({
          key: news.ID,
          title: news.title,
          create_time: news.create_time,
          type: news.type,
          image: news.url_picture === "" ? "https://studiovietnam.com/wp-content/uploads/2020/08/chup-anh-san-pham-phong-thuy-6.jpg" : news.url_picture,
          number_read: news.number_read,
          news_info: news.news_info
        })));
      }
    } catch (error) {
      console.error("Lỗi khi lấy dữ liệu sản phẩm:", error);
    }
    setLoading(false);
  };

  const handleCreateNews = () => {
    setEditingNews(null); // Xóa dữ liệu cũ
    setIsModalVisible(true); // Mở modal
  };

  const handleEditNews = () => {
    setEditingNews(selectedNews); // Gán sản phẩm cần chỉnh sửa
    setIsModalVisible(true); // Mở modal
  };

  // Cột bảng
  const columns = [
    {
      title: "Tên bài viết",
      dataIndex: "title",
      key: "title",
      render: (text, record) => (
        <Radio
          checked={selectedNews?.key === record.key}
          onChange={() => setSelectedNews(record)}
        >
          {text}
        </Radio>
      ),
    },
    {
      title: "Loại bài viết",
      dataIndex: "type",
      key: "type",
    },
    {
      title: "Thời gian tạo",
      dataIndex: "create_time",
      key: "create_time",
      // render: (text) => <a href={text} target="_blank" rel="noopener noreferrer">{text}</a>,
    },

    {
      title: "Số lượt truy cập",
      dataIndex: "number_read",
      key: "number_read",
    },
  ];

  return (
    <div>
      {/* Bảng sản phẩm */}
      <Card
        title="📊 THỐNG KÊ CÁC BÀI VIẾT"
        extra={
          <>
            <Button icon={<ReloadOutlined />} style={{ marginRight: "10px" }}>Tải Lại</Button>
            <Button onClick={() => setIsModalVisible(true)} type="primary" icon={<PlusOutlined />}>Tạo Sản Phẩm Mới</Button>
          </>
        }
        style={{ marginBottom: "20px", }}
      >
        <Table columns={columns} dataSource={news} pagination={{ pageSize: 10 }} />
      </Card>

      {/* Modal add new product */}
      <ProductModal
        visible={isModalVisible}
        onClose={() => setIsModalVisible(false)}
      />

      {/* Chi tiết sản phẩm */}
      {selectedNews && (
        <Card
          title={`📦 Dòng sản phẩm: ${selectedNews.name}`}
          extra={<Button icon={<EditOutlined />}>Sửa Đổi Thông Tin</Button>}
        >
          <Tabs defaultActiveKey="1">
            <TabPane tab="Thông tin chi tiết dòng sản phẩm" key="1">
              <Image width={300} src={selectedNews.image} />
            </TabPane>
          </Tabs>
        </Card>
      )}
    </div>
  );
};

export default NewsManagement;